import { Component, OnInit } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { ApiService } from "src/app/api.service";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { AuthenticationService } from "src/app/_services";
import { SecurityDocument } from "src/app/shared/models/SecurityDocument";
import { TovpilUtilsService } from "src/app/utils/tovpil-utils.service";
import { TranslateRelLabelVO } from "src/app/shared/models/TranslateRelLabelVO";
import { TovpilLanguageService } from "src/app/utils/tovpil-language.service";

@Component({
  selector: "app-workshop-assistance",
  templateUrl: "./workshop-assistance.component.html",
  styleUrls: ["./workshop-assistance.component.scss"],
  providers: [MessageService, ConfirmationService],
})
export class WorkshopAssistanceComponent implements OnInit {
  currentUser: any;
  security: SecurityDocument;
  token: string;
  device: string;
  workShopDetail: any;
  dataParent: any;
  blocked: boolean = true;

  listParticipantAny: any;

  cols: any[];
  sessions: any[];
  clonedSession = {};

  /** LABELS */
  translations: Record<string, string> = {};
  totalList: any;
  editingRowIndex: number = -1;

  // RESTAURAR ROWS
  rowCloned: any;

  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private translationService: TovpilLanguageService,
    private tovpilUtils: TovpilUtilsService
  ) {
    const navigation = this.router.getCurrentNavigation();
    this.dataParent = navigation.extras.state as any;

    this.route.queryParams.subscribe((params) => {
      this.token = params.token;
      this.device = params.device;
    });
  }

  ngOnInit(): void {
    if (this.dataParent) {
      this.security = this.dataParent.security;
      this.workShopDetail = this.dataParent.workshop;

      this.getSecurity();
    } else {
      this.redirectWorkShop();
    }
  }

  redirectWorkShop() {
    let queryParamsDetail = {};
    if (this.token && this.device) {
      queryParamsDetail = {
        token: this.token,
        device: this.device,
      };
    }
    let navigationExtras: NavigationExtras = {
      queryParams: queryParamsDetail,
    };

    this.router.navigate(["guide/workshops"], navigationExtras);
  }

  getSecurity() {
    if (!this.security) {
      this.apiService
        .findSecurityById({ id: this.currentUser.tokenProfile })
        .then((data) => {
          this.security = data;
          this.getTranslatedLabels();
        });
    } else {
      this.getTranslatedLabels();
    }
    if (!this.workShopDetail) {
    }
  }

  /**
   * The function `getTranslatedLabels` is an asynchronous function that retrieves translated labels from
   * a translation service and sets them in the `translations` variable, and then calls another function
   * `getLanguages`.
   */
  async getTranslatedLabels() {
    try {
      const language = this.security.language;
      const region = this.security.region;  
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();
      this.loadParticipants();
     
    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
      this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}` });
      this.loadParticipants();
      // Error al traer labels traducidos
    }
  }

  async loadParticipants() {
    this.blocked = true;
    let body = {
      wrksId: this.workShopDetail.f0.wrksId,
      language: this.security.language,
    };
    this.listParticipantAny = [];
    this.cols = [];
    this.cols = [
      { id: "session", header: "SessionNum", shortName: "SessionNum" },
    ];

    let finalRows = [];
    let rows;
    let data = await this.apiService.getListAssitanceWorkshop(body);
    this.blocked = false;
    this.listParticipantAny = data;
    this.calculateTotal();
    rows = this.listParticipantAny[0].sessions.length;

    // Aqui se cargan los headers de la tabla
    if (this.listParticipantAny.length > 0) {
      let index = 0;
      for (let p of this.listParticipantAny) {
        let head = {
          header: p.participant.name,
          id : p.participant.particiId,
          shortName: p.partShortName
        };
        index++;
        this.cols.push(head);
      }

      // Aqui se rellenan las rows con los datos que deben llevar las filas
      for (let i = 0; i < rows; i++) {
        let object = {};
        for (let p of this.listParticipantAny) {
          if (!Object.keys(object).includes(p.wrksId)) {
            object['wrksId'] = p.wrksId;
          }
          if (!Object.keys(object).includes(p.sessions[i].sessNum)) {
            object['session'] = p.sessions[i].sessNum;
          }
          let objectPerson = {
            particiId : p.participant.particiId,
            name : p.participant.name,
            isAssist : p.sessions[i].isAssist,

          }
          object[p.participant.particiId] = objectPerson;
        }
        console.log(object);
        finalRows.push(object);
      }
      this.sessions = finalRows;
      console.log("sesiones: " + this.sessions)
    }
  }

  calculateTotal() {
    const sessionsArrays = this.listParticipantAny.map((p) => p["sessions"]);
    const mergedSessions = [].concat(...sessionsArrays);

    this.totalList = mergedSessions.reduce((acc, session) => {
      const existingSession = acc.find((s) => s.sessNum === session.sessNum);

      if (existingSession) {
        existingSession.isAssist += session.isAssist ? 1 : 0;
      } else {
        acc.push({
          isAssist: session.isAssist ? 1 : 0,
          sessNum: session.sessNum,
        });
      }

      return acc;
    }, []);
  }

  /**
   * The `deepClone` function recursively creates a deep copy of an object or array in TypeScript.
   * @param obj - The `obj` parameter in the `deepClone` function is the object that you want to create a
   * deep copy of. The function recursively clones the object and all its nested properties to create a
   * new object that is completely independent of the original object.
   * @returns The `deepClone` function is returning a deep copy of the input `obj`, meaning it creates a
   * new object or array with all nested objects and arrays also deeply copied.
   */
  deepClone(obj) {
    if (obj === null || typeof obj !== "object") {
      return obj;
    }

    const cloned = Array.isArray(obj) ? [] : {};

    for (let key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        cloned[key] = this.deepClone(obj[key]);
      }
    }

    return cloned;
  }

  /**
   * The `onRowEditInit` function initializes the editingRowIndex and clones the rowData if it has not
   * been cloned before.
   * @param rowData - The `rowData` parameter in the `onRowEditInit` function represents the data of the
   * row being edited in a table or list. It contains the information and values of the row that the user
   * is currently editing.
   * @param {number} ri - The `ri` parameter in the `onRowEditInit` function represents the index of the
   * row being edited in the list of participants.
   */
  onRowEditInit(session) {
    this.clonedSession[session.session] = session;
  }

  /**
   * The function `onRowEditCancel` sets the `editingRowIndex` to -1 to cancel row editing.
   * @param {any} assist - The `assist` parameter in the `onRowEditCancel` function is of type `any`,
   * which means it can accept any type of value. In this context, it seems like `assist` is not being
   * used in the function, so it may be a placeholder or a parameter that was intended
   */
  onRowEditCancel(session, index: number) {
    this.sessions[index] = this.clonedSession[session.session];
    delete this.clonedSession[session.session];
  }

  /**
   * The function `onRowEditSave` handles saving edited row data and displaying success or error messages
   * accordingly.
   * @param {any} assist - The `assist` parameter in the `onRowEditSave` function seems to be an object
   * that contains information about a workshop assistance. It includes properties such as `participant`,
   * `wrksId`, and `sessions`. The `participant` property likely contains details about the participant
   * attending the workshop.
   * @param {number} ri - The `ri` parameter in the `onRowEditSave` function represents the index of the
   * row that is being edited or saved. It is used to identify the specific row in the list of
   * participants or data being manipulated in the function.
   */
  async onRowEditSave(session) {
    console.log(session);

    let keys = Object.keys(session);
    console.log('antes de eliminar', keys);
    keys.shift();
    keys.shift();

    let participants = [];
    console.log('despues de eliminar',keys);
    for(let i of keys){
      let p = {
        participId : session[i].particiId,
        isAssist : session[i].isAssist,
      }
      participants.push(p);
    }
    let body = {
      sessNum : session.session,
      wrksId : session.wrksId,
      sessionsPart : participants
    };

    // Aqui se usa el servicio
    let data = await this.apiService.createUpdateListAttendBySession(body);
    this.messageService.add({ severity: 'success', summary: this.translations.lbl_updated_data, life: 5000 });
  }

  getDetailForm0() {
    this.apiService
      .getDetailForm0({
        wrksId: this.workShopDetail.f0.wrksId,
      })
      .then((data) => {
        this.workShopDetail.f0.partN15s = data.partN15s;
        this.workShopDetail.f0.partN2s = data.partN2s;
      });
  }

  prependSessionIfContainsNumber(header: string): string {
    if (/\d/.test(header)) {
      return "Sesión No° " + header;
    }
    return header;
  }
}
